/* HOT DOGUE · Favoritos: corazón en cada prenda, guardado en el navegador de la clienta. */
(function () {
  var KEY = 'hd_favoritos';
  var cfg = window.HDFav || {};
  var t = cfg.t || {};

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('hdfav:change', { detail: list }));
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var list = read(), i = list.indexOf(h);
    if (i === -1) list.unshift(h); else list.splice(i, 1);
    write(list);
    return i === -1;
  }
  function handleFrom(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.2-9.4C1.6 7.6 3.9 4 7.4 4c2 0 3.5 1.1 4.6 2.7C13.1 5.1 14.6 4 16.6 4c3.5 0 5.8 3.6 4.6 7.1-1.7 4.8-9.2 9.4-9.2 9.4z"/></svg>';

  function paint(btn) {
    var on = has(btn.dataset.handle);
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? t.remove : t.add);
    var lbl = btn.querySelector('.sd-fav__label');
    if (lbl) lbl.textContent = on ? t.saved : t.save;
  }

  var toastTimer;
  function toast(msg) {
    var el = document.querySelector('.sd-fav-toast');
    if (!el) {
      el = document.createElement('a');
      el.className = 'sd-fav-toast';
      el.href = cfg.url || '/pages/favoritos';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2400);
  }

  function makeBtn(handle, withLabel) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sd-fav' + (withLabel ? ' sd-fav--label' : '');
    b.dataset.handle = handle;
    b.innerHTML = HEART + (withLabel ? '<span class="sd-fav__label"></span>' : '');
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var added = toggle(handle);
      b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
      toast(added ? t.toast_added : t.toast_removed);
    });
    paint(b);
    return b;
  }

  function addTo(container, handle) {
    if (!container || !handle || container.querySelector(':scope > .sd-fav')) return;
    if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
    container.appendChild(makeBtn(handle));
  }

  var SKIP = 'header, cart-drawer, .cart-drawer, .sd-upsell, .predictive-search, .sd-favoritos, product-info, .product';

  function scan(root) {
    // Fichas normales de la tienda (colecciones, búsqueda, relacionados)
    root.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.closest(SKIP)) return;
      var a = card.querySelector('a[href*="/products/"]');
      addTo(card.querySelector('.card__inner'), a && handleFrom(a.getAttribute('href')));
    });
    // Carruseles y secciones propias: enlaces de producto con foto
    root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.closest('.card-wrapper') || a.closest(SKIP)) return;
      var img = a.querySelector('img');
      if (!img) return;
      addTo(img.closest('.sd-car__media') || img.parentElement, handleFrom(a.getAttribute('href')));
    });
  }

  function productPage() {
    if (!cfg.product) return;
    var title = document.querySelector('.product__title');
    if (!title || document.querySelector('.sd-fav--label')) return;
    title.insertAdjacentElement('afterend', makeBtn(cfg.product, true));
  }

  function badge() {
    var n = read().length;
    document.querySelectorAll('.sd-fav-count').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  document.addEventListener('hdfav:change', function () {
    document.querySelectorAll('.sd-fav').forEach(paint);
    badge();
  });
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) document.dispatchEvent(new CustomEvent('hdfav:change', { detail: read() }));
  });

  function init() {
    scan(document);
    productPage();
    badge();
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.HDFavStore = { read: read, toggle: toggle, makeBtn: makeBtn };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
